import { ElementType } from './scan.enum';

export class BarcodeElements {
    public ai: string;
    public dataTitle: string;
    public data: string | number | Date;
    public unit: string;
    public rawData: string;

    public constructor(
        elementAI: string,
        elementDataTitle: string,
        elementType: ElementType,
        data = '',
        public isDataParsedFromPlugin = true,
    ) {
        this.ai = elementAI; // application identifier
        this.dataTitle = elementDataTitle; // title
        switch (elementType) {
            case ElementType.String:
                this.data = data; // the contents
                break;
            case ElementType.Number:
                this.data = 0;
                break;
            case ElementType.Date:
                this.data = new Date();
                this.data.setUTCHours(0, 0, 0, 0);
                break;
            default:
                this.data = '';
                break;
        }
        this.unit = ''; // some elements are accompanied by an unit of measurement or currency
        this.rawData = data.toString();
    }
}

export class ParsedBarcodeElement {
    public element: BarcodeElements;
    public codeString: string;

    public constructor(element: BarcodeElements, codeString: string) {
        this.element = element;
        this.codeString = codeString;
    }
}
